export const GET_CHECKOUT_PAGE_START = 'GET_CHECKOUT_PAGE_START';
export const GET_CHECKOUT_PAGE_SUCCESS = 'GET_CHECKOUT_PAGE_SUCCESS';
export const GET_CHECKOUT_PAGE_FAIL = 'GET_CHECKOUT_PAGE_FAIL';

export const CREATE_PAYMENT_START = 'CREATE_PAYMENT_START';
export const CREATE_PAYMENT_SUCCESS = 'CREATE_PAYMENT_SUCCESS';
export const CREATE_PAYMENT_FAIL = 'CREATE_PAYMENT_FAIL';
export const RESET_PAYMENT_DATA = 'RESET_PAYMENT_DATA';

export const AUTHORIZE_PAYMENT_METHOD_START = 'AUTHORIZE_PAYMENT_METHOD_START';
export const AUTHORIZE_PAYMENT_METHOD_FAIL = 'AUTHORIZE_PAYMENT_METHOD_FAIL';
export const AUTHORIZE_PAYMENT_METHOD_SUCCESS = 'AUTHORIZE_PAYMENT_METHOD_SUCCESS';

export const SET_SELECTED_CURRENCY = 'SET_SELECTED_CURRENCY';
export const SET_SELECTED_TYPE = 'SET_SELECTED_TYPE';
export const RESET_SELECTED_TYPE = 'RESET_SELECTED_TYPE';
export const SET_SELECTED_PAYMENT_METHOD_TYPE = 'SET_SELECTED_PAYMENT_METHOD_TYPE';
export const SET_SELECTED_CATEGORY = 'SET_SELECTED_CATEGORY';
export const SET_REQUIRED_FIELDS = 'SET_REQUIRED_FIELDS';
export const SET_REQUIRED_FIELDS_LOADING = 'SET_REQUIRED_FIELDS_LOADING';
export const SET_CONDITIONAL_FIELDS = 'SET_CONDITIONAL_FIELDS';
export const CLEAR_REQUIRED_FIELDS = 'CLEAR_REQUIRED_FIELDS';
export const SET_PM_OPTIONS = 'SET_PM_OPTIONS';
export const CLEAR_PM_OPTIONS = 'CLEAR_PM_OPTIONS';
export const SET_SELECTED_BANK_PAYMENT_METHOD = 'SET_SELECTED_BANK_PAYMENT_METHOD';
export const SET_ADD_PAYMENT_METHOD_MODE = 'SET_ADD_PAYMENT_METHOD_MODE';

export const DISABLE_CARD_ABSTRACTION = 'DISABLE_CARD_ABSTRACTION';
export const CARD_ABSTRACION_ERROR = 'card_abstraction_error_description';
export const CLEAR_CUSTOM_ERROR = 'CLEAR_CUSTOM_ERROR';

export const RESET_CHECKOUT_STORE = 'RESET_CHECKOUT_STORE';

export const HAS_MERCHANT_TRIGGERED_SDK_SUBMIT = 'HAS_MERCHANT_TRIGGERED_SDK_SUBMIT';
